module.exports = __webpack_public_path__ + "img/laugh.027cd4eb.png";